import Trip from "./Trip";
import * as Car from "../data/Car";
import { TripType } from "../data/FrontendTypes";
import AddIcon from '@mui/icons-material/Add';
import { useState, useEffect, useRef } from 'react';

let currentId = 0;

function generateId(): number {
    return ++currentId;
}

type props = {
    name: string;
    list: TripType [];
    setList: (trips: TripType[]) => void;
    toCustomer: boolean;
    save: () => void;
}

export default function TripList({name, list, setList, toCustomer, save}: props): React.ReactElement {
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

    const initialListRef = useRef<TripType[]>([]);

    useEffect(() => {
        initialListRef.current = JSON.parse(JSON.stringify(list));
    }, []);

    useEffect(() => {
        const hasChanges = JSON.stringify(list) !== JSON.stringify(initialListRef.current);
        setHasUnsavedChanges(hasChanges);
    }, [list]);

    function addNewTrip(): void {
        const newTrip = Car.createTrip(toCustomer)
        setList([...list, newTrip])
    } 

    function removeTrip(index: number): void {
        setList(list.filter((_, i) => i !== index));
    }        

    const handleSave = () => {
        save();
        initialListRef.current = JSON.parse(JSON.stringify(list));
        setHasUnsavedChanges(false);
    }

    return (
        <div className="trip-list">
            <h2>{name}</h2>
            <div className="anfahrten-liste">
                <div className="anfahrten">
                    { list.map((trip, index) =>
                        <Trip
                            key={index}
                            value={trip}
                            id={generateId()}
                            setValue={(updatedTrip: TripType) => {
                                setList(
                                    list.map((t, i) => i === index ? updatedTrip : t)
                                );
                            }}
                            toCustomer={toCustomer}
                            deleteSelf={() => removeTrip(index)}
                        />
                    )}
                    <div className="trip-list-footer">
                        <button className='add-trip button-transparent' onClick={() => addNewTrip()}>
                            <AddIcon/> Hinzufügen
                        </button>
                        <button 
                            className='save button-transparent' 
                            onClick={handleSave}
                            disabled={!hasUnsavedChanges}
                        >
                            Speichern
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

